import { shortenNumber } from '../utilities/index'

export default {
  methods: {
    configureDateTime(sections, dateTime, finalEndTime) {
      const graphData = this.formattedGraphData || this.graphData
      if (dateTime) {
        const dateWords = dateTime.split(' ')
        sections.push(`${dateWords[0]}`)

        let hourSpanString = `@ ${dateWords[1]}`

        const currentIndex = graphData.findIndex(data => data.date_time === dateTime)
        const onLastIndex = graphData.length === currentIndex + 1

        if (!onLastIndex) {
          hourSpanString += ' - ' + graphData[currentIndex + 1]['date_time'].split(' ')[1]
        } else if (finalEndTime) {
          hourSpanString += ' - ' + finalEndTime.split(' ')[1]
        }

        sections.push(hourSpanString)
      }
      return sections
    },

    getRecipientContent(itemData) {
      let sections = [],
        recipient = itemData['recipient'],
        nonrecipient = itemData['nonrecipient']

      if (recipient !== undefined && nonrecipient !== undefined) {
        recipient = shortenNumber(recipient, this.useCurrency)
        nonrecipient = shortenNumber(nonrecipient, this.useCurrency)
        sections.push(recipient, 'vs', nonrecipient)
      }

      if (itemData['date_time']) {
        const dateWords = itemData['date_time'].split(' ')
        sections.push(`${dateWords[0]}`, `@ ${dateWords[1]}`)
      }

      return sections
    },

    getOccurringContent(itemData) {
      let sections = [],
        amount = itemData['amount']

      if (amount !== undefined) {
        const shortAmount = shortenNumber(amount, this.useCurrency)
        sections.push(shortAmount)
      }

      return this.configureDateTime(sections, itemData['date_time'], itemData['final_end_time'])
    },

    getTrendLineContent(itemData) {
      let sections = [],
        amount = itemData['amount']

      if (amount !== undefined) {
        const fixedAmount = amount % 1 !== 0 ? amount.toFixed(2) : amount
        const shortAmount = shortenNumber(fixedAmount, this.useCurrency)

        sections.push(shortAmount)

        if (this.reportDataType === 'visits') {
          sections.push(shortAmount == 1 ? 'visit' : this.reportDataType)
        }
      }

      return this.configureDateTime(sections, itemData['date_time'], itemData['final_end_time'])
    },

    getOptoutContent(itemData) {
      if (itemData) {
        const amount = itemData['amount'], 
              sections = [amount, `opt out${amount !== 1 ? 's' : ''}`]

        return this.configureDateTime(sections, itemData['date_time'], itemData['final_end_time'])
      }
    },

    getToolTipContent(itemData, graphType) {
      let content = [];
      switch (graphType) {
        case 'occurring':
          content = this.getOccurringContent(itemData)
          break;
        case 'recipients':
          content = this.getRecipientContent(itemData)
          break;
        case 'trends':
          content = this.getTrendLineContent(itemData)
          break;
        case 'optout':
          content = this.getOptoutContent(itemData)
          break;
      }
      return content;
    },
  }
}
